import { db } from "@/firebase/init.js";
import {
  // General
  doc,
  // Get All
  getDoc,
  // Get by Sort
  setDoc,
  updateDoc,
} from "firebase/firestore";

const contactusModule = {
  namespaced: true, // automatically added
  state: {
    contactus: {},
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getContactus: (state) => state.contactus,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Contactus
    //// Get  Contactus
    setContactus: (state, payload) => {
      state.contactus = payload;
    },
  },
  actions: {
    // Get Contactus
    async fetchContactus({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);

      const contactus = await getDoc(doc(db, "Contact_Us", "contactUs"));
      let contactusData = {
        facebook: "",
        youtube: "",
        twitter: "",
        telegram: "",
        phone_numbers: [],
        address: [],
      };

      if (contactus.exists()) {
        contactusData = contactus.data();
      } else {
        console.log("No Contactus found");
        await setDoc(doc(db, "Contact_Us", "contactUs"), {
          ...contactusData,
        });
      }
      commit("setContactus", contactusData);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return contactusData;
    },

    // Update Contact us
    async updateContact({ commit }, payload) {
      updateDoc(doc(db, "Contact_Us", "contactUs"), payload);
      commit("setContactus", payload);
    },
  },
};

export default contactusModule;
